import { LEAFLINK_NO_LONGER_OPEN_STATUSES } from '../constants/leaflink-no-longer-open-statuses.js';
/** LeafLink order statuses at which an action has nothing left to do; a rejected order is no longer open, so a cancel is done too. */
export const LEAFLINK_STATUSES_REFLECTING_ACTION = {
    accept: ['Accepted'],
    cancel: LEAFLINK_NO_LONGER_OPEN_STATUSES,
    complete: ['Complete'],
    fulfill: ['Fulfilled'],
    reject: ['Rejected'],
    ship: ['Shipped'],
};
//# sourceMappingURL=leaflink-statuses-reflecting-action.js.map